import { MenuContext } from './MenuContext';
export function MenuProvider(props) {
    const { children, controlled, close } = props;
    return <MenuContext.Provider value={{ controlled, close }}>{children}</MenuContext.Provider>;
}
